import { render, staticRenderFns } from "./Grids.vue?vue&type=template&id=c38b95ca&"
import script from "./Grids.vue?vue&type=script&lang=js&"
export * from "./Grids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports